/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pluginConfig: {},
  frontendConfig: {},
  entityTypes: [],
};

export const TenantSlicer = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    setPluginConfig: (state, action) => {
      state.pluginConfig = action?.payload;
    },
    setFrontendConfig: (state, action) => {
      state.frontendConfig = action.payload;
    },
    setEntityTypes: (state, action) => {
      state.entityTypes = action?.payload || [];
    },
  },
});

export const { setPluginConfig, setFrontendConfig, setEntityTypes } =
  TenantSlicer.actions;

export default TenantSlicer.reducer;
